import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import ReportParameters from "../report-contents-page/ReportParameters";
const MissingParametersForWidgetPreview = ({
  parameters,
  parameterValues: initialParameterValues,
  onSubmit,
  parameterSearchIds
}) => {
  const [parameterValues, setParameterValues] = useState(initialParameterValues);
  const addParameterValue = useCallback(
    (name, value) => setParameterValues((oldParameterValues) => ({ ...oldParameterValues, [name]: value })),
    []
  );
  const _onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit(parameterValues);
    },
    [onSubmit, parameterValues]
  );
  return /* @__PURE__ */ React.createElement("form", { id: "report-widget-preview-parameters", onSubmit: _onSubmit }, /* @__PURE__ */ React.createElement("p", null, "This widget is requiring mandatory parameters for execution. Please complete the missing values below."), /* @__PURE__ */ React.createElement(
    ReportParameters,
    {
      parameters,
      parameterValues,
      onChange: addParameterValue,
      parameterSearchIds
    }
  ), /* @__PURE__ */ React.createElement(Button, { type: "submit", form: "report-widget-preview-parameters", bsStyle: "primary" }, "Preview"));
};
export default MissingParametersForWidgetPreview;
